export const setupIframely = (key) => {
  const script = document.createElement("script")

  script.src = `//cdn.iframe.ly/embed.js?api_key=${key}`
  script.async = true
  script.charset = 'utf-8'

  document.body.appendChild(script)
}
